import React, { createContext, useContext, useEffect, useState } from "react";

const InventoryProductContext = createContext();

export const InventoryProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [combinedSelectedItems, setCombinedSelectedItems] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [isValidWithOTP, setIsValidWithOTP] = useState(false);
  const [uomData, setUomData] = useState([])
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  //   handle Filter 
  const [updateApplyFilterOptions, setUpdateApplyFilterOptions] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [selectedItemCategoryCode, setSelectedItemCategoryCode] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  //   Brand Data
  const [brandData, setBrandData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [packagingData, setPackagingData] = useState([]);
  const tokenData = localStorage.getItem("auth-token");
  //SKU
  const [selectedSku, setSelectedSku] = useState([]);
  const [skuData, setSkuData] = useState([]);

  //   Category
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [itemCategoryCodeData, setItemCategoryCodeData] = useState([]);

  // fetch selected data
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedItemCategoryCodes, setSelectedItemCategoryCodes] = useState(
    []
  );
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedPackaging, setSelectedPackaging] = useState([]);
  const [isRealLoading, setIsRealLoading] = useState(false);

  // fetch Data ends

  const [inventoryFilteredProducts, setInventoryFilteredProducts] = useState([])

  //   Table input field
  const [requestedQuantities, setRequestedQuantities] = useState({});
  const [counterOffers, setCounterOffers] = useState({});

  // Filter Category Based on Filter
  const [newFilterData, setNewFilterData] = useState([])
  const validNewCustomer = localStorage.getItem('validNewCustomer') === true

  // Filter Condition UseState
  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleWidth = () => {
    setIsExpanded(!isExpanded);
  };
  // Amit
  const [showApplyFilterOptions, setShowApplyFilterOptions] = useState(false);
  const clearAllFilterOptions = () => {
    setCategoryData([]);
    setSubCategoryData([]);
    setBrandData([]);
    setItemCategoryCodeData([]);
    setColorData([]);
    setPackagingData([]);
    setSelectedUOM('');
    setSelectedSku([]);


  }

  const cacheName = "test-inventory-cache";

  // without Cache

  // const fetchAndCacheData = async () => {
  //   setIsLoading(true)
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",

  //            "OData-MaxVersion": "4.0",
  //             "OData-Version": "4.0"
  //           },
  //       }
  //     );
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch data from server");
  //     }

  //     const data = await response.json();
  //     const cacheStorage = await caches.open(cacheName);
  //     await cacheStorage.put(
  //       `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`,
  //       new Response(JSON.stringify(data))
  //     );
  //     // // console.log("Data stored in cache:", data);
  //     setIsLoading(false)
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching and caching data:", error);
  //     setIsLoading(false)
  //     throw error; // Propagate the error further
  //   }
  // };


  // const fetchDataFromCache = async () => {
  //   setIsLoading(true);
  //   const cacheName = "test-inventory-cache";
  //   const cacheStorage = await caches.open(cacheName);
  //   const cacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`;

  //   try {
  //     const cachedResponse = await cacheStorage.match(cacheUrl);

  //     if (cachedResponse) {
  //       const cachedData = await cachedResponse.json();
  //       // console.log("Data fetched from cache:", cachedData);
  //       setProducts(cachedData);
  //       await fetchAndTransformData();

  //       // Filter and set the inventory filtered products
  //       //const filteredData = cachedData.filter(product => product.strava_availablequantity > 0);
  //       //setInventoryFilteredProducts(filteredData);

  //       setIsLoading(false);

  //       return cachedData;
  //     } else {
  //       return await fetchAndCacheData();
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data from cache:", error);
  //     setIsLoading(false);
  //     throw error; // Propagate the error further
  //   }
  // };
  const cacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`;

  //With Etag only
  // const fetchAndCacheData = async () => {
  //     setIsLoading(true);
  //     try {
  //         const response = await fetch(cacheUrl, {
  //             method: "GET",
  //             headers: {
  //                 "Content-Type": "application/json",
  //                 "OData-MaxVersion": "4.0",
  //                 "OData-Version": "4.0",
  //                 "Prefer": "odata.include-annotations"
  //             },
  //         });

  //         if (!response.ok) {
  //             throw new Error("Failed to fetch data from server");
  //         }

  //         const data = await response.json();
  //         const cacheStorage = await caches.open(cacheName);

  //         await cacheStorage.put(
  //             cacheUrl,
  //             new Response(JSON.stringify(data), {
  //                 headers: {
  //                     "ETag": response.headers.get("ETag") || "",
  //                 }
  //             })
  //         );

  //         setIsLoading(false);
  //         return data;
  //     } catch (error) {
  //         console.error("Error fetching and caching data:", error);
  //         setIsLoading(false);
  //         throw error; // Propagate the error further
  //     }
  // };

  // const fetchDataFromCache = async () => {
  //     setIsLoading(true);

  //     try {
  //         const cacheStorage = await caches.open(cacheName);
  //         const cachedResponse = await cacheStorage.match(cacheUrl);

  //         const headers = {};

  //         if (cachedResponse) {
  //             const cachedETag = cachedResponse.headers.get("ETag");
  //             if (cachedETag) headers["If-None-Match"] = cachedETag;

  //             const serverResponse = await fetch(cacheUrl, {
  //                 method: "GET",
  //                 headers,
  //             });

  //             if (serverResponse.status === 304) {
  //                 // Not Modified
  //                 const cachedData = await cachedResponse.json();
  //                 // console.log("Data fetched from cache:", cachedData);
  //                 setProducts(cachedData);
  //                 setIsLoading(false);
  //                 return cachedData;
  //             }

  //             if (serverResponse.ok) {
  //                 // Data has changed on the server, update the cache
  //                 const data = await serverResponse.json();
  //                 await cacheStorage.put(
  //                     cacheUrl,
  //                     new Response(JSON.stringify(data), {
  //                         headers: {
  //                             "ETag": serverResponse.headers.get("ETag") || "",
  //                         }
  //                     })
  //                 );

  //                 setProducts(data);
  //                 setIsLoading(false);
  //                 return data;
  //             }
  //         } else {
  //             // No data in cache, fetch from server
  //             return await fetchAndCacheData();
  //         }
  //     } catch (error) {
  //         console.error("Error fetching data from cache:", error);
  //         setIsLoading(false);
  //         throw error; // Propagate the error further
  //     }
  // };

  //Latest cache
  const fetchAndCacheData = async (modifiedDate) => {

    try {
      const response = await fetch(cacheUrl, {
        method: "GET",
        headers: {
          "time-cached": modifiedDate,
          "Content-Type": "application/json",
          "OData-MaxVersion": "4.0",
          "OData-Version": "4.0",
          "Prefer": "odata.include-annotations"
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from server");
      }

      const newData = await response.json();
      const cacheStorage = await caches.open(cacheName);
      const cachedResponse = await cacheStorage.match(cacheUrl);

      let cachedData = cachedResponse ? await cachedResponse.json() : [];
      const cachedDataMap = new Map(cachedData.map(product => [product.productid, product]));

      // Update or add products based on the new data
      newData.forEach(product => {
        if (product.productid) {
          cachedDataMap.set(product.productid, product);
        }
      });

      // Convert the Map back to an array
      const finalData = Array.from(cachedDataMap.values());

      // Store the final data in cache
      await cacheStorage.put(
        cacheUrl,
        new Response(JSON.stringify(finalData), {
          headers: {
            "etag": response.headers.get("ETag") || "",
            "time-cached": new Date().toISOString(), // Store the updated time when data was cached
          }
        })
      );

      setProducts(finalData);
      setIsLoading(false);
      return finalData;
    } catch (error) {
      console.error("Error fetching and caching data:", error);
      setIsLoading(false);
      throw error; // Propagate the error further
    }
  };

  const fetchDataFromServer = async (modifiedDate) => {
    setIsLoading(false);
    setIsRealLoading(true);
    try {
      let modifiedDate = "1999-01-01T00:00:00Z";
      // Fetch data from server with appropriate headers
      const response = await fetch(cacheUrl, {
        method: "GET",
        headers: {
          "If-Modified-Since": modifiedDate, // Use standard header if supported by server
          "Content-Type": "application/json",
          "OData-MaxVersion": "4.0",
          "OData-Version": "4.0",
          "Prefer": "odata.include-annotations"
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch data from server: ${response.statusText}`);
      }
      const data = await response.json();
      setProducts(data);
      const cacheStorage = await caches.open(cacheName);
      await cacheStorage.put(
        cacheUrl,
        new Response(JSON.stringify(data), {
          headers: {
            "etag": response.headers.get("ETag") || "", // ETag header for cache validation
            "time-cached": new Date().toISOString() // Store the time when data was cached
          }
        })
      );
      setIsRealLoading(false);
      return data;
    } catch (error) {
      // Log and handle errors
      console.error("Error fetching and caching data:", error);
      setIsRealLoading(false);
      throw error; // Propagate the error further
    }
  };
  const fetchDataFromCache = async () => {
    setIsLoading(true);
  
    try {
      const cacheStorage = await caches.open(cacheName);
      const cachedResponse = await cacheStorage.match(cacheUrl);

      let modifiedDate = "1999-01-01T00:00:00Z"; // Default date in UTC
      let headers = {
        "time-cached": modifiedDate,
        "Content-Type": "application/json",
        "OData-MaxVersion": "4.0",
        "OData-Version": "4.0",
        "Prefer": "odata.include-annotations"
      };

      if (cachedResponse) {
        // Retrieve the headers and data
        const cachedData = await cachedResponse.json();
        if (!cachedData) { return await fetchDataFromServer(modifiedDate); }

        setProducts(cachedData);
        setIsLoading(false);

        const cachedETag = cachedResponse.headers.get("ETag");
        if (cachedETag) {
          headers["If-None-Match"] = cachedETag;
        }

        const timeCached = cachedResponse.headers.get("time-cached");
        if (timeCached) {
          modifiedDate = new Date(timeCached).toISOString();
          headers["time-cached"] = modifiedDate;
        }


        // Make a request to the server, passing the modified date and ETag as headers
        const serverResponse = await fetch(cacheUrl, {
          method: "GET",
          headers: headers
        });
        // console.log("Response Status", serverResponse.status)
        if (serverResponse.status === 304 && cachedResponse) {
          // console.log("Data not modified on server, use cached data");
          const cachedData = await cachedResponse.json();
          setProducts(cachedData);
          setIsLoading(false);
          return cachedData;
        }

        if (serverResponse.ok) {
          // console.log("Data has changed on the server, update the cache");
          return await fetchAndCacheData(modifiedDate);
        }
      } else {
        // No data in cache, fetch from server if no data available
        {
          return await fetchDataFromServer(modifiedDate);
        }
        throw new Error("Failed to fetch data from server");
      }
    } catch (error) {
      console.error("Error fetching data from cache:", error);
      setIsLoading(false);
      throw error; // Propagate the error further
    }
  };

  // useEffect(() => {
  //   fetchDataFromCache();
  // }, []);

  // Function to check the value in localStorage and update the state
  const checkValidWithOTP = () => {
    const storedValue = localStorage.getItem("callApiData");
    setIsValidWithOTP(storedValue === "true");
  };

  // useEffect to check when the component mounts and when localStorage changes
  useEffect(() => {
    // Check on component mount
    checkValidWithOTP();
    // Listen for localStorage changes (useful for multi-tab scenarios)
    const handleStorageChange = () => {
      checkValidWithOTP();
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // useEffect to react when validWithOTP changes to true
  useEffect(() => {
    if (isValidWithOTP) {
      // Trigger your desired action here
      // console.log("validWithOTP is true, triggering useEffect!");
      fetchDataFromCache();
      // You can add your function call or other logic here
    }
  }, [isValidWithOTP]);



  const filterProductsByIncomingQuantity = () => {
    return products.filter((product) => {
      // Filter out products where strava_availablequantity is not greater than 0
      return product.strava_availablequantity > 0;
    });
  };

  const fetchAndTransformData = async () => {
    const filteredData = filterProductsByIncomingQuantity();
    setInventoryFilteredProducts(filteredData);
  };


  // Fetching Product from Catch to Display the category, SubCategory, and rest of the filter 

  const fetchProductData = (products, labelKey, valueKey) => {
    if (!Array.isArray(products)) {
      window.location.reload(); // Refresh the page if products is null or not an array
      return []; // Return an empty array as a fallback
    }

    const uniqueItems = new Set();
    return products
      .map((product) => {
        const label = product[labelKey];
        const value = product[valueKey];
        if (!label || !value) return null;
        return { label: label, value: value };
      })
      .filter((item) => item !== null)
      .filter((item) => {
        if (!uniqueItems.has(item.label)) {
          uniqueItems.add(item.label);
          return true;
        }
        return false;
      });
  };

  const fetchUOMProductData = (products, labelKey, valueKey) => {
    if (!Array.isArray(products)) {
      window.location.reload(); // Refresh the page if products is null or not an array
      return []; // Return an empty array as a fallback
    }

    const uniqueItems = new Map();

    products.forEach((product) => {
      const label = product[labelKey];
      const value = product[valueKey];
      if (!label || !value) return;

      const normalizedLabel = label.toLowerCase();

      if (!uniqueItems.has(normalizedLabel)) {
        uniqueItems.set(normalizedLabel, {
          label: label, // Original label case
          value: [value], // Store values as an array to accumulate variants
        });
      } else {
        uniqueItems.get(normalizedLabel).value.push(value);
      }
    });

    return Array.from(uniqueItems.values()).map((item) => {
      return {
        label: item.label,
        value: Array.from(new Set(item.value)).join(", "), // Ensure uniqueness in case of duplicate values
      };
    });
  };


  const fetchCategoryProductData = (products) =>
    fetchProductData(
      products,
      "strava_categories@OData.Community.Display.V1.FormattedValue",
      "strava_categories@OData.Community.Display.V1.FormattedValue"
    );
  const fetchSubCategoryProductData = (products) =>
    fetchProductData(
      products,
      "strava_subcategories@OData.Community.Display.V1.FormattedValue",
      "strava_subcategories@OData.Community.Display.V1.FormattedValue"
    );

  const fetchItemCategoryCodeData = (products) =>
    fetchProductData(
      products,
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue",
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"
    );
  const fetchBrandProductData = (products) =>
    fetchProductData(products, "nyc_brand", "nyc_brand");
  const fetchColorProductData = (products) =>
    fetchProductData(products, "nyc_color", "nyc_color");
  const fetchPackagingProductData = (products) =>
    fetchProductData(products, "nyc_packaging", "nyc_packaging");
  const fetchUomProductData = (products) =>
    fetchUOMProductData(products, "nyc_sizeuom", "nyc_sizeuom");

  const fetchFilterData = async (products) => {
    const categoryData = fetchCategoryProductData(products);
    const subCategoryData = fetchSubCategoryProductData(products);
    const itemCategoryCodeData = fetchItemCategoryCodeData(products);
    const brandData = fetchBrandProductData(products);
    const colorData = fetchColorProductData(products);
    const packagingData = fetchPackagingProductData(products);
    const uomData = fetchUomProductData(products)
    fetchFilteredProducts()
    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData);
    setItemCategoryCodeData(itemCategoryCodeData)
    setBrandData(brandData);
    setColorData(colorData);
    setPackagingData(packagingData);
    setUomData(uomData);
  };

  useEffect(() => {
    fetchFilterData(products);
  }, [products]);

  //   handle Checkbox checked
  useEffect(() => {
    const initializeCategories = () => {
      const savedCategories = localStorage.getItem('selectedCategories');
      try {
        const parsedCategories = savedCategories ? JSON.parse(savedCategories) : [];
        // console.log("ParsedCategory",parsedCategories)
        setSelectedCategories(parsedCategories)
        setShowApplyFilterOptions(true) // Call your function with the parsed categories
        return parsedCategories;
      } catch (error) {
        console.error('Error parsing sessionStorage data:', error);
        return [];
      }
    };
    if (!validNewCustomer) {
      initializeCategories()
    }
  }, [isValidWithOTP])

  const handleCheckboxChange = (setSelectedItems) => (item) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(item.value)) {
        return prevSelected.filter((value) => value !== item.value);
      } else {
        return [...prevSelected, item.value];
      }
    });
    // updateFilterData();
  };

  // Algo Pix Call

  const [showPopup, setShowPopup] = useState(false);
  const handleButtonClick = (upcNumber) => {
    setShowPopup(true);
    fetchAlgopixData(upcNumber);
  };

  const handleCloseClick = () => {
    setShowPopup(false);
  };

  const [algopixdata, setAlgoPixdata] = useState(null);
  const [amazonData, setAmazonData] = useState(null);
  const [ebayData, setEbayData] = useState(null);
  const [walmartData, setWalmartData] = useState(null);

  const fetchAlgopixData = async (upcNumber) => {
    // console.log("inside fetchAlgopixData", upcNumber); 
    try {

      const keywords = "017801147025";

      const url = `${process.env.REACT_APP_SERVER_URL}/api/atu/get-algopix-data?keywords=${keywords}`;


      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch token');
      }

      const data = await response.json();
      // console.log(data.result);
      setAlgoPixdata(data.result);
      const amazon = data.result.offers.find(offer => offer.marketBrand === 'AMAZON');
      const ebay = data.result.offers.find(offer => offer.marketBrand === 'EBAY');
      const walmart = data.result.offers.find(offer => offer.marketBrand === 'WALMART');

      // console.log(amazon);
      // console.log(ebay);
      // console.log(walmart);
      setAmazonData(amazon);
      setEbayData(ebay);
      setWalmartData(walmart);

    } catch (error) {
      // console.log("Erron", error)
    }
  };

  // console.log("Products list", products, 278)
  const [newProduct, setNewProduct] = useState([]);
  const [filterByLast30Days, setFilterByLast30Days] = useState(false);
  const filternewProducts = () => {
    // const filtered = inventoryFilteredProducts.filter(product => product.nyc_receivedinlast30days === true)
    // // console.log("new product", newProduct)
    // setNewProduct(filtered);
    // setInventoryFilteredProducts(filtered);
    setFilterByLast30Days(true); // Toggle the filter state
  }

  useEffect(() => {
    if (filterByLast30Days) {
      fetchFilteredProducts();
    }
  }, [filterByLast30Days])

  const [exportExcelName, setExportExcelName] = useState(null);
  const [selectedUOM, setSelectedUOM] = useState('');
  const handleUOMChange = (event) => {
    setSelectedUOM(event.target.value);
    setIsRangeChanged(true)
  };
  const fetchFilteredProducts = async () => {
    try {

      const categoryData = new Set(selectedCategories);
      const subCategoryData = new Set(selectedSubCategories);
      const itemCategoryData = new Set(selectedItemCategoryCodes);
      const brandCategoryData = new Set(selectedBrands);
      const colorSelectedData = new Set(selectedColors);
      const packagingSelectedData = new Set(selectedPackaging);
      const skuData = new Set(selectedSku);
      // Ensure selectedUOM is an array and split it if necessary
      const uomArray = Array.isArray(selectedUOM) ? selectedUOM : selectedUOM.split(',').map(uom => uom.trim().toLowerCase());
      const uomSet = new Set(uomArray);

      // if (selectedCategories.length !== 0) {
      //   setExportExcelName(selectedCategories[0] + "_" + (selectedCategories?.[1] || ''));
      // } else if (selectedBrands.length !== 0) {
      //   setExportExcelName(selectedBrands[0] + "_" + (selectedBrands?.[1] || ''));
      // } else {
      //   setExportExcelName(null);
      // }

      if (filterByLast30Days) {
        if (selectedCategories.length !== 0) {
          setExportExcelName("New_ProductList" + selectedCategories[0] + "_" + (selectedCategories?.[1] || ''));
        } else if (selectedBrands.length !== 0) {
          setExportExcelName("New_ProductList" + selectedBrands[0] + "_" + (selectedBrands?.[1] || ''));
        } else {
          setExportExcelName("New_ProductList");
        }
      } else {
        if (selectedCategories.length !== 0) {
          setExportExcelName(selectedCategories[0] + "_" + (selectedCategories?.[1] || ''));
        } else if (selectedBrands.length !== 0) {
          setExportExcelName(selectedBrands[0] + "_" + (selectedBrands?.[1] || ''));
        } else {
          setExportExcelName(null);
        }
      }


      // Perform filtering
      const filtered = products.filter(product => {
        const productUOM = product.nyc_sizeuom?.toLowerCase();
        const matchesUOM = !uomSet.size || uomSet.has("") || uomSet.has(productUOM);
        /// SKU filtering logic for A stock and B stock
        let skuDatalogic = true; // Default to true if no specific stock filter is applied.

        const isAStockSelected = skuData.has("A Stock");
        const isBStockSelected = skuData.has("B Stock");

        // If both "A stock" and "B stock" are selected, show all products (no filtering on -B)
        if (isAStockSelected && isBStockSelected) {
          skuDatalogic = true;
        }
        // If "A stock" is selected but not "B stock", exclude products containing `-B`
        else if (isAStockSelected) {
          skuDatalogic = !product.productnumber.includes("-B");
        }
        // If "B stock" is selected but not "A stock", include products containing `-B`
        else if (isBStockSelected) {
          skuDatalogic = product.productnumber.includes("-B");
        }
        const matchesLast30Days = filterByLast30Days
          ? product.nyc_receivedinlast30days === true
          : true;
        return (
          (product.strava_availablequantity > 0) && matchesLast30Days &&
          (!categoryData.size || categoryData.has(product["strava_categories@OData.Community.Display.V1.FormattedValue"])) &&
          (!subCategoryData.size || subCategoryData.has(product["strava_subcategories@OData.Community.Display.V1.FormattedValue"])) &&
          (!itemCategoryData.size || itemCategoryData.has(product["strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"])) &&
          (!brandCategoryData.size || brandCategoryData.has(product.nyc_brand)) &&
          (!colorSelectedData.size || colorSelectedData.has(product.nyc_color)) &&
          (!packagingSelectedData.size || packagingSelectedData.has(product.nyc_packaging)) &&
          matchesUOM && skuDatalogic
        );
      });

      setInventoryFilteredProducts(filtered);
      setFetchCompleted(true);
      setUpdateApplyFilterOptions(true);
      // await fetchDataBasedOnConditions()
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };


  const fetchApplyFilteredProducts = async () => {
    try {
      // Convert selected filter values to appropriate types
      const categoryData = selectedCategories; // Assuming categories are integers
      const subCategoryData = selectedSubCategories; // Assuming subcategories are integers
      const itemCategoryData = selectedItemCategoryCodes; // Assuming item category codes are integers
      const brandCategoryData = selectedBrands;
      const colorSelectedData = selectedColors;
      const packagingSelectedData = selectedPackaging

      // console.log("CatDataatat",categoryData)
      // console.log("subCategoryData",subCategoryData)
      // console.log("itemCategoryData",itemCategoryData)
      // console.log("brandCategoryData",brandCategoryData)
      // console.log("colorSelectedData",colorSelectedData)

      // Perform filtering
      const filtered = products.filter(product => {
        return (
          (!categoryData.length || categoryData.includes(product["strava_categories@OData.Community.Display.V1.FormattedValue"])) &&
          (!subCategoryData.length || subCategoryData.includes(product["strava_subcategories@OData.Community.Display.V1.FormattedValue"])) &&
          (!itemCategoryData.length || itemCategoryData.includes(product["strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"])) &&
          (!brandCategoryData.length || brandCategoryData.includes(product.nyc_brand)) &&
          (!colorSelectedData.length || colorSelectedData.includes(product.nyc_color)) &&
          (!packagingSelectedData.length || packagingSelectedData.includes(product.nyc_packaging)) &&
          (!skuData.length || skuData.includes(product.productnumber))
        );
      });

      setInventoryFilteredProducts(filtered);
      setFetchCompleted(true)
      // await fetchDataBasedOnConditions()
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };


  // console.log("setInventoryFilteredProducts", inventoryFilteredProducts,316)



  const clearAllFilters = () => {
    setFilterByLast30Days(false);
    setShowApplyFilterOptions(false);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedItemCategoryCodes([])
    setSelectedColors([]);
    setSelectedPackaging([]);
    setSelectedBrands([]);
    setIsRangeChanged(false)
    fetchDataFromCache();
    setSelectedUOM('');
    setIsSelectAllChecked(false);
    setSelectedSku([]);


  };



  // Based on filter Fetching other filter

  // For Category


  const fetchAfterSelectFilterData = (selectedData, labelKey, valueKey) => {
    const uniqueItems = new Set();
    return selectedData
      .map((product) => {
        const label = product[labelKey];
        const value = product[valueKey];
        if (!label || !value) return null;
        return { label: label, value: value };
      })
      .filter((item) => item !== null)
      .filter((item) => {
        if (!uniqueItems.has(item.label)) {
          uniqueItems.add(item.label);
          return true;
        }
        return false;
      });
  };

  const fetchFilterCategoryProductData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(
      inventoryFilteredProducts,
      "strava_categories@OData.Community.Display.V1.FormattedValue",
      "strava_categories@OData.Community.Display.V1.FormattedValue"
    );

  const fetchFilterSubCategoryProductData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(
      inventoryFilteredProducts,
      "strava_subcategories@OData.Community.Display.V1.FormattedValue",
      "strava_subcategories@OData.Community.Display.V1.FormattedValue"
    );

  const fetchFilterItemCategoryCodeData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(
      inventoryFilteredProducts,
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue",
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"
    );

  const fetchFilterBrandData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(inventoryFilteredProducts, "nyc_brand", "nyc_brand");

  const fetchFilterPackagingData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(inventoryFilteredProducts, "nyc_packaging", "nyc_packaging");

  const fetchFilterColorData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(inventoryFilteredProducts, "nyc_color", "nyc_color");




  // CategoryFilter
  const fetchCategoryData = async (inventoryFilteredProducts) => {
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setSubCategoryData(subCategoryData);
    setBrandData(brandData);
    setPackagingData(packagingData);
    setColorData(colorData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // SubCategoryFilter
  const fetchSubCategoryData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setBrandData(brandData);
    setPackagingData(packagingData);
    setColorData(colorData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // BrandFilter
  const fetchBrandData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setPackagingData(packagingData);
    setColorData(colorData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // ItemCategoryCode Filter
  const fetchItemCategoryData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setPackagingData(packagingData);
    setColorData(colorData);
  };

  // ColorFilter
  const fetchColorData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setPackagingData(packagingData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // PackagingFilter
  const fetchPackagingData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setItemCategoryCodeData(itemCategoryCodeData);
    setColorData(colorData)
  };

  // PackagingFilter
  const fetchAllData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setItemCategoryCodeData(itemCategoryCodeData);
    setColorData(colorData)
    setPackagingData(packagingData)
  };


  const fetchDataBasedOnConditions = async () => {
    const hasSelectedFilters = [
      selectedCategories,
      selectedSubCategories,
      selectedBrands,
      selectedItemCategoryCode,
      selectedColors,
      selectedPackaging
    ].some(filter => filter.length > 0);


    if (selectedCategories.length) {
      await fetchCategoryData(inventoryFilteredProducts);
    }

    if (selectedSubCategories.length) {
      await fetchSubCategoryData(inventoryFilteredProducts);
    }

    if (selectedBrands.length) {
      await fetchBrandData(inventoryFilteredProducts);
    }

    if (selectedItemCategoryCode.length) {
      // console.log("Year are here only")
      await fetchItemCategoryData(inventoryFilteredProducts);
    }

    if (selectedColors.length) {
      await fetchColorData(inventoryFilteredProducts);
    }

    if (selectedPackaging.length) {
      await fetchPackagingData(inventoryFilteredProducts);
    }

    if (!hasSelectedFilters) {
      await fetchAllData(inventoryFilteredProducts);
    }
  };


  useEffect(() => {
    if (fetchCompleted) {
      fetchDataBasedOnConditions()
      setFetchCompleted(false)
    }
  }, [fetchCompleted])


  // Top Filter End's here 


  const [isRangeChanged, setIsRangeChanged] = useState(false);


  const [ranges, setRanges] = useState({
    nyc_msrp: [0, 1000],
    size: [0, 1000],
    price: [0, 1000],
  });
  const [minMax, setMinMax] = useState({
    nyc_msrp: [0, 1000],
    size: [0, 1000],
    price: [0, 1000],
  });

  useEffect(() => {
    const initRange = (type) => {
      const values = products.map(product => parseFloat(product[type])).filter(value => !isNaN(value));
      const min = Math.min(...values);
      const max = Math.max(...values);
      return [min, max];
    };

    setRanges({
      nyc_msrp: initRange('nyc_msrp'),
      size: initRange('size'),
      price: initRange('price'),
    });

    setMinMax({
      nyc_msrp: initRange('nyc_msrp'),
      size: initRange('size'),
      price: initRange('price'),
    });
  }, [products]);

  const setRange = (type, range) => {
    setRanges(prevRanges => ({ ...prevRanges, [type]: range }));
    setIsRangeChanged(true);
  };

  const handleFilter = () => {
    let filtered = inventoryFilteredProducts;
    Object.keys(ranges).forEach(type => {
      filtered = filtered.filter(product => {
        const value = parseFloat(product[type]);
        return value >= ranges[type][0] && value <= ranges[type][1];
      });
    });
    setInventoryFilteredProducts(filtered);
    // setIsRangeChanged(false);
  };


  useEffect(() => {
    if (fetchCompleted) {
      handleFilter();
      setFetchCompleted(false);
    }
  }, [fetchCompleted]);

  return (
    <InventoryProductContext.Provider
      value={{
        products,
        handleCheckboxChange,
        brandData,
        setBrandData,
        colorData,
        setColorData,
        packagingData,
        setPackagingData,
        selectedBrands,
        setSelectedBrands,
        selectedColors,
        setSelectedColors,
        selectedPackaging,
        setSelectedPackaging,
        //
        categoryData,
        selectedCategory,
        setSelectedCategory,
        subCategoryData,
        selectedSubCategory,
        itemCategoryCodeData,
        setSelectedSubCategory,
        selectedItemCategoryCode,
        setSelectedItemCategoryCode,

        selectedCategories,
        setSelectedCategories,
        selectedSubCategories,
        setSelectedSubCategories,
        selectedItemCategoryCodes,
        setSelectedItemCategoryCodes,

        inventoryFilteredProducts,
        fetchFilteredProducts,
        clearAllFilters,
        setRequestedQuantities, setCounterOffers,
        counterOffers, requestedQuantities,
        // addToCart,
        fetchDataFromCache,
        handleFilter,
        ranges,
        minMax,
        setRanges,
        setRange,
        isRangeChanged,
        setIsRangeChanged,
        fetchApplyFilteredProducts,
        isLoading,
        //Algo pix
        handleButtonClick,
        handleCloseClick,
        showPopup,
        algopixdata,
        amazonData,
        ebayData,
        walmartData,
        showApplyFilterOptions, setShowApplyFilterOptions,
        // Amit 02-08-2024
        updateApplyFilterOptions, setUpdateApplyFilterOptions,
        setNewProduct,
        newProduct,
        filternewProducts,
        combinedSelectedItems, setCombinedSelectedItems, isClicked, setIsClicked,
        clearAllFilterOptions,
        exportExcelName,
        uomData,
        selectedUOM, setSelectedUOM, handleUOMChange, isExpanded, setIsExpanded,
        toggleWidth, isSelectAllChecked, setIsSelectAllChecked, selectedSku,
        setSelectedSku,
        skuData,
        setSkuData,
        setFilterByLast30Days,
        isRealLoading
      }}
    >
      {children}
    </InventoryProductContext.Provider>
  );
};

export const useInventoryProductContext = () => {
  const context = useContext(InventoryProductContext);
  if (context === undefined) {
    throw new Error(
      "useInventoryProductContext must be used within a InventoryProductProvider"
    );
  }
  return context;
};
